import ShareableLinkRejectedFromWaitingRoom from './ShareableLinkRejectedFromWaitingRoom.component';

export default ShareableLinkRejectedFromWaitingRoom;